module.exports = __webpack_public_path__ + "static/media/feather-alt.5ade927c.svg";